export default __webpack_public_path__ + "static/media/ugovor-o-pripajanju2.14f1b1c3.pdf";